import { bookedSlots, conflictSlot, services, staff } from "./data";

export const formatMoney = (value: number) =>
  new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND", maximumFractionDigits: 0 }).format(value);

export const getSelectedServices = (ids: string[]) => services.filter((service) => ids.includes(service.id));

export const getBookingTotals = (ids: string[]) => {
  const selected = getSelectedServices(ids);
  return {
    price: selected.reduce((sum, service) => sum + service.price, 0),
    duration: selected.reduce((sum, service) => sum + service.duration, 0)
  };
};

export const getEligibleStaff = (serviceIds: string[]) => {
  if (!serviceIds.length) return [];
  return staff.filter((member) =>
    serviceIds.every((serviceId) => services.find((service) => service.id === serviceId)?.staffIds.includes(member.id))
  );
};

export const isBooked = (staffId: string, date: string, time: string) =>
  bookedSlots.has(`${staffId}|${date}|${time}`);

export const isConflict = (staffId: string, date: string, time: string) =>
  `${staffId}|${date}|${time}` === conflictSlot;

export const getDateLabel = (iso: string) =>
  new Intl.DateTimeFormat("vi-VN", { weekday: "short", day: "2-digit", month: "2-digit" }).format(
    new Date(`${iso}T12:00:00+07:00`)
  );
